/**
 * Fire-and-forget click tracking for the public link-in-bio page (Phase 5).
 * Uses Supabase Edge Function + anon key; failures are ignored.
 */

export function getLinkInBioTrackClickFunctionUrl() {
  const explicit = import.meta.env.VITE_LINK_IN_BIO_TRACK_CLICK_URL;
  if (explicit) {
    return String(explicit).replace(/\/$/, "");
  }
  const base = import.meta.env.VITE_SUPABASE_URL;
  if (!base) {
    return "";
  }
  return `${String(base).replace(/\/$/, "")}/functions/v1/link-in-bio-track-click`;
}

/**
 * @param {{ slug: string; buttonKey: string; project?: string | null }} params
 * `project` should match `get_public_link_in_bio_by_slug` → `finitless_project` when present (optional validation server-side).
 */
export function trackLinkInBioClick({ slug, buttonKey, project }) {
  const url = getLinkInBioTrackClickFunctionUrl();
  const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;
  const normalizedSlug = slug ? String(slug).trim().toLowerCase() : "";
  const key = buttonKey ? String(buttonKey).trim().slice(0, 64) : "";
  const projectTrim =
    project != null && String(project).trim() !== ""
      ? String(project).trim()
      : "";

  if (!url || !anon || !normalizedSlug || !key) {
    return;
  }

  const payload = {
    slug: normalizedSlug,
    button_key: key,
    ...(projectTrim ? { project: projectTrim } : {}),
  };
  const body = JSON.stringify(payload);

  try {
    void fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${anon}`,
        apikey: anon,
      },
      body,
      keepalive: true,
    });
  } catch {
    // ignore
  }
}
